import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-gif',
  templateUrl: './loader-gif.component.html',
  styleUrls: ['./loader-gif.component.scss']
})
export class LoaderGifComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4208491149/src/src/app/common/loader-gif/loader-gif.component.ts